import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

import CenteredCircularProgress from '../../../../lib/designSystem/CircularProgress';
import EnhancedTab from '../../../../lib/designSystem/TabSimulation';
import {
  validateCompanyTypes,
  validatePermissions,
} from '../../../../lib/functions/utils';
import { AuthState } from '../../../../services/redux/authSlice';
import FactoringResells from './FactoringFundReSell';
import FactoringResellsNominees from './FactoringFundReSellNominees';
import FactoringFundReSellPayments from './FactoringFundReSellPayments';
import FundSummary from './FundSummary';

const Funds: React.FC = () => {
  const { subPage } = useParams<{ subPage: string }>();

  const [loading, setLoading] = useState(true);
  const [companyTabs, setCompanyTabs] = useState<any>([]);
  const user = useSelector((state: { auth: AuthState }) => state.auth.user);
  const [startValue, setStartValue] = useState(0);
  const navigate = useNavigate();

  const handleNavigation = (index: number) => {
    navigate(`/finance/funds/${companyTabs[index].path}`);
  };

  const fetchRelations = async () => {
    setLoading(true);
    const newCompanyTabs = [];
    if (validateCompanyTypes(user, 'FactoringQuoting')) {
      if (validateCompanyTypes(user, 'FinancingHub')) {
        newCompanyTabs.push({
          label: 'Resumen',
          component: <FundSummary />,
          path: 'summary',
        });

        if (validatePermissions(user, 'financing_fundSale_view'))
          newCompanyTabs.push({
            label: 'Nóminas',
            component: <FactoringResellsNominees />,
            path: 'nominees',
            disabled: !validatePermissions(user, 'financing_fundSale_view'),
          });
        newCompanyTabs.push({
          label: 'Documentos',
          component: <FactoringResells />,
          path: 'sells',
          disabled: !validatePermissions(user, 'financing_fundSale_view'),
        });
        if (validatePermissions(user, 'financing_fundSale_payments_view'))
          newCompanyTabs.push({
            label: 'Pagos',
            component: <FactoringFundReSellPayments />,
            path: 'payments',
          });
      }
    }
    const startingIndex = newCompanyTabs.findIndex(
      (x: any) => x.path === subPage,
    );
    setCompanyTabs(newCompanyTabs);
    setStartValue(startingIndex > 0 ? startingIndex : 0);
    setLoading(false);
  };

  useEffect(() => {
    fetchRelations();
  }, []);

  if (loading) return <CenteredCircularProgress />;

  return (
    <div>
      <EnhancedTab
        startValue={startValue}
        tabs={companyTabs}
        onTabChange={handleNavigation}
      />
    </div>
  );
};

export default Funds;
